export const RATING_LABELS = {
  '1': 'Shumë e dobët',
  '2': 'Nën pritshmëri',
  '3': 'Përmbush pritshmëritë',
  '4': 'Tejkalon pritshmëritë',
  '5': 'E shkëlqyer',
}

export const RATING_COLORS = {
  '1': '#f4516c',
  '2': '#ffb822',
  '3': '#5867dd',
  '4': '#34bfa3',
  '5': '#0abb87',
}

export const RECOMMEND_COLORS = {
  po: '#0abb87',
  jo: '#f4516c',
  ndoshta: '#ffb822',
}

export const RECOMMEND_LABELS = { po: 'Po', jo: 'Jo', ndoshta: 'Ndoshta' }

// For the exit "repeated complaints" question: Po (has complaints) = bad/red, Jo = good/green
export const YESNO_COLORS = { po: '#f4516c', jo: '#0abb87' }
export const YESNO_LABELS = { po: 'Po', jo: 'Jo' }

// Questions 1–4 shared
const SHARED_QUESTIONS = [
  { key: 'q0', label: 'Performanca e përgjithshme', commentKey: 'q0_comment', type: 'rating' },
  { key: 'q1', label: 'Sjellja profesionale & etika e punës', commentKey: 'q1_comment', type: 'rating' },
  { key: 'q2', label: 'Pikat kryesore të forcës', type: 'text' },
  { key: 'q3', label: 'Fushat që kërkojnë përmirësim', type: 'text' },
]

export const PROBATION_QUESTIONS = [
  ...SHARED_QUESTIONS,
  { key: 'q4', label: 'Rekomandim për vazhdimin e kontratës', commentKey: 'q4_comment', type: 'recommend' },
]

export const EXIT_QUESTIONS = [
  ...SHARED_QUESTIONS,
  { key: 'q5', label: 'Informatë shtesë për riangazhim të mundshëm', type: 'text' },
  { key: 'q6', label: 'Ankesa të përsëritura nga klientë/kolegë', commentKey: 'q6_comment', type: 'yesno' },
]

// RENEWAL: shorter set — performance, behavior, and continuation recommendation
export const RENEWAL_QUESTIONS = [
  { key: 'q0', label: 'Performanca e përgjithshme', commentKey: 'q0_comment', type: 'rating' },
  { key: 'q1', label: 'Sjellja profesionale & etika e punës', commentKey: 'q1_comment', type: 'rating' },
  { key: 'q4', label: 'Rekomandim për vazhdimin e kontratës', commentKey: 'q4_comment', type: 'recommend' },
]

export const getDisplayQuestions = (type) => {
  if (type === 'exit') return EXIT_QUESTIONS
  if (type === 'renewal') return RENEWAL_QUESTIONS
  return PROBATION_QUESTIONS
}
